import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import { Small } from '../../../components/Typography';
import {Link} from "react-router-dom";

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main },
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '14px',
  fontWeight: '500',
  color: theme.palette.primary.main,
}));

const StatCards = ({dashboard_data}) => {

  const cardList = [
    { name: 'Active Products', amount: dashboard_data.active_products, icon: 'inventory' , to: "/product/all/3"},
    { name: 'Sales', amount: `৳${dashboard_data.total_sale}`, icon: 'add_card' , to: "/orders/3"},
    { name: 'Completed Orders', amount: `${dashboard_data.completed_orders}`, icon: 'shopping_bag', to: "/orders/3" },
    { name: 'Orders to deliver', amount: `${dashboard_data.orders_to_deliver} Orders`, icon: 'shopping_cart_checkout', to: "/orders/2"},
  ];

  return (
    <Grid container spacing={3} sx={{ mb: '24px' }}>
      
    </Grid>
  );
};

export default StatCards;
